module.exports = __webpack_public_path__ + "img/KARE_LOGO_PNG_2020-01.86a3eb2e.png";